import React from "react";
import ConveniosYearPage from "./ConveniosYearPage";
import { convenios2025 } from "../../../../data/Convenios/dataConvenios";

const Convenios2025 = () => <ConveniosYearPage year={2025} data={convenios2025} />;

export default Convenios2025;